import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {UrlHelper} from '../../helper/url.helper';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  supportEmail: string;
  supportEmailLabel: string;

  constructor() {
    this.supportEmailLabel = environment.contacts.supportEmail;
    this.supportEmail = 'mailto:' + this.supportEmailLabel;
  }

  ngOnInit(): void {
  }

  get homeUrl() {
    return UrlHelper.DEFAULT_AUTH_PATH;
  }

}
